import { Avatar, Box, Checkbox, FormControlLabel } from '@mui/material';
import PrimaryField from './Components/PrimaryField';
import { stringToColor } from '@utils/colorUtils';
import { get } from 'lodash';
import { JSONPath } from 'jsonpath-plus';
import { CheckRounded } from '@mui/icons-material';

export const ContactField = ({
    row,
    primaryField = 'display_name',
    secondaryField = 'description',
    avatar,
    maxWidth,
    checked,
    handleCheck,
}) => {
    const primary = get(row, primaryField, '');

    return (
        <Box display="flex" alignItems="center" gap={2}>
            <FormControlLabel
                sx={{ margin: 0 }}
                onClick={e => e.stopPropagation()}
                label={
                    <>
                        <Avatar
                            className="row-not-hover"
                            src={row.profile_picture}
                            sx={{
                                display: checked ? 'none' : 'flex',
                                bgcolor:
                                    !row.profile_picture &&
                                    stringToColor(primary),
                            }}
                        >
                            {avatar || primary.getNameInitials()}
                        </Avatar>
                        <Avatar
                            className="row-hover"
                            sx={{
                                display: checked ? 'flex' : 'none',
                                bgcolor: checked
                                    ? 'primary.main'
                                    : 'action.hover',
                                ...(!checked
                                    ? {
                                          ':hover': {
                                              bgcolor: 'action.selected',
                                          },
                                      }
                                    : {}),
                                color: !checked && 'primary.main',
                            }}
                        >
                            <CheckRounded sx={{ fontSize: 28 }} />
                        </Avatar>
                    </>
                }
                control={
                    <Checkbox
                        checked={checked}
                        onChange={handleCheck}
                        sx={{ display: 'none' }}
                    />
                }
            />
            <Box maxWidth={maxWidth}>
                <PrimaryField
                    primary={primary}
                    secondary={JSONPath({
                        json: row,
                        path: secondaryField,
                    }).join(', ')}
                />
            </Box>
        </Box>
    );
};
